import { render, staticRenderFns } from "./TourClone.vue?vue&type=template&id=b1d8d79e"
import script from "./TourClone.vue?vue&type=script&lang=js"
export * from "./TourClone.vue?vue&type=script&lang=js"
import style0 from "./TourClone.vue?vue&type=style&index=0&id=b1d8d79e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports